import { render } from "./NearProperties.vue?vue&type=template&id=3c7aa4e7"
import script from "./NearProperties.vue?vue&type=script&lang=js"
export * from "./NearProperties.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__